(function () {
    var typed = '';
    var TRIGGER = 'judge';

    document.addEventListener('keypress', function (e) {
        typed += e.key.toLowerCase();
        if (typed.length > TRIGGER.length) typed = typed.slice(-TRIGGER.length);
        if (typed === TRIGGER) {
            typed = '';
            spawnJudge();
        }
    });


    function spawnJudge() {
        if (document.querySelector('.judge-overlay')) return;

        var overlay = document.createElement('div');
        overlay.className = 'judge-overlay';

        var quote = document.createElement('p');
        quote.className = 'judge-quote';
        quote.textContent = '„Whatever in creation exists without my knowledge exists without my consent."';

        var attr = document.createElement('span');
        attr.className = 'judge-attr';
        attr.textContent = '— Judge Holden, Blood Meridian';

        // Judge Holden: massive pale/white hairless giant
        var figure = document.createElement('div');
        figure.className = 'judge-figure';
        var c = '#d8cfc4'; // pale, almost albino
        figure.innerHTML = '<svg viewBox="0 0 300 520" xmlns="http://www.w3.org/2000/svg" width="300" height="520">'
            // Left arm — hanging naturally, long
            + '<path d="M85 230 Q55 290 50 390 Q65 395 78 388 Q80 300 100 248Z" fill="' + c + '"/>'
            // Right arm — hanging naturally, long
            + '<path d="M215 230 Q245 290 250 390 Q235 395 222 388 Q220 300 200 248Z" fill="' + c + '"/>'
            // Torso — wide, tapers slightly
            + '<path d="M75 225 Q60 340 65 520 L235 520 Q240 340 225 225 Q195 210 150 208 Q105 210 75 225Z" fill="' + c + '"/>'
            // Neck
            + '<rect x="132" y="178" width="36" height="36" rx="3" fill="' + c + '"/>'
            // Head — tall oval, bald
            + '<ellipse cx="150" cy="118" rx="62" ry="72" fill="' + c + '"/>'
            // Subtle brow ridge shadow
            + '<path d="M100 132 Q150 125 200 132" fill="none" stroke="rgba(0,0,0,0.18)" stroke-width="5"/>'
            // Eye sockets — dark hollows
            + '<ellipse cx="125" cy="145" rx="11" ry="8" fill="rgba(40,0,0,0.55)"/>'
            + '<ellipse cx="175" cy="145" rx="11" ry="8" fill="rgba(40,0,0,0.55)"/>'
            // Pupils — small dark
            + '<circle cx="125" cy="145" r="4" fill="rgba(20,0,0,0.8)"/>'
            + '<circle cx="175" cy="145" r="4" fill="rgba(20,0,0,0.8)"/>'
            + '</svg>';

        overlay.appendChild(quote);
        overlay.appendChild(attr);
        overlay.appendChild(figure);

        var closeBtn = document.createElement('button');
        closeBtn.className = 'ee-close';
        closeBtn.textContent = '×';
        closeBtn.addEventListener('click', function () {
            overlay.classList.add('judge-overlay--fade');
            setTimeout(function () { overlay.remove(); }, 1400);
        });
        overlay.appendChild(closeBtn);
        document.body.appendChild(overlay);

        setTimeout(function () {
            overlay.classList.add('judge-overlay--fade');
            setTimeout(function () { overlay.remove(); }, 1400);
        }, 3800);
    }
})();
